"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildInsufficientCapabilitiesMockData = exports.buildRadarEarlyFraudMockData = exports.buildDisputeClosedOrganizationMockData = exports.buildDisputeCreatedOrganizationMockData = void 0;
const organization_facing_base_1 = require("./organization-facing-base");
const DISPUTE_PAYMENT_DEFAULTS = {
    firstName: "John",
    description: "Donation to Bright Futures Foundation",
    amount: "$120.00",
    date: "March 14, 2026 at 9:00 AM",
};
const buildDisputeCreatedOrganizationMockData = ({ locale = "en", subject = "Your donor has disputed a payment", ...payment } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    ...DISPUTE_PAYMENT_DEFAULTS,
    ...payment,
});
exports.buildDisputeCreatedOrganizationMockData = buildDisputeCreatedOrganizationMockData;
const buildDisputeClosedOrganizationMockData = ({ locale = "en", subject = "The result of your dispute is available", ...payment } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    ...DISPUTE_PAYMENT_DEFAULTS,
    ...payment,
});
exports.buildDisputeClosedOrganizationMockData = buildDisputeClosedOrganizationMockData;
const buildRadarEarlyFraudMockData = ({ locale = "en", subject = "An action is required for this transaction", donorEmail = "jane.donor@example.com", ...payment } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    ...DISPUTE_PAYMENT_DEFAULTS,
    ...payment,
    donorEmail,
});
exports.buildRadarEarlyFraudMockData = buildRadarEarlyFraudMockData;
const buildInsufficientCapabilitiesMockData = ({ locale = "en", subject = "Payouts paused via user request from bank account change email", alertSubject = "Payouts paused via user request from bank account change email", alertMessage = "The organization Bright Futures Foundation (acct_1234567890) has paused payouts via user request from bank account change email", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    alertSubject,
    alertMessageHtml: (0, organization_facing_base_1.embedPlainTextForMock)(alertMessage).replace("Bright Futures Foundation (acct_1234567890)", '<strong style="font-weight: 700;">Bright Futures Foundation (acct_1234567890)</strong>'),
});
exports.buildInsufficientCapabilitiesMockData = buildInsufficientCapabilitiesMockData;
